import { css } from '@linaria/core'

/**
 * Self-hosted brand fonts.
 *
 * Nunito follows the rounded logo and is the only family every page uses; the
 * wordmark remains original artwork. Instrument Sans is the fallback if Nunito
 * fails to load, and IBM Plex Mono carries tabular figures across wallets,
 * rider earnings and the operations tables.
 *
 * Only families that something actually references belong here. An unused
 * @font-face is not free: it ships in the bundle and sits in the deployed
 * assets, and a stray reference to it would quietly start a download nobody
 * budgeted. `fonts.test.ts` fails if a family is declared but never referenced.
 */
export const fontFacesClass = css`
  :global() {
  @font-face {
    font-family: "Nunito";
    src: url("/fonts/nunito-variable.woff2") format("woff2");
    font-weight: 200 1000;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: "Instrument Sans";
    src: url("/fonts/instrument-sans-variable.woff2") format("woff2-variations");
    font-weight: 400 700;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: "IBM Plex Mono";
    src: url("/fonts/ibm-plex-mono-400.woff2") format("woff2");
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: "IBM Plex Mono";
    src: url("/fonts/ibm-plex-mono-500.woff2") format("woff2");
    font-weight: 500;
    font-style: normal;
    font-display: swap;
  }
  }
`

/** Kept so mounting code does not change: the rules above load with this module (extracted CSS). */
export function FontFaces(): null {
  return null
}
